import api from './api';
import { useWallets } from '@privy-io/react-auth';

// Create embedded wallet for user
export const createWallet = async (userId: string) => {
  try {
    const token = localStorage.getItem('auth_token') || localStorage.getItem('privy:token');
    
    // Set the auth token in headers
    const response = await api.post('/wallet/create', { userId }, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error creating wallet:', error);
    throw error;
  }
};

// Get wallet balance (generic - not Solana specific)
export const getWalletBalance = async (walletAddress: string) => {
  try {
    const token = localStorage.getItem('auth_token') || localStorage.getItem('privy:token');
    
    // Set the auth token in headers
    const response = await api.get(`/wallet/balance/${walletAddress}`, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting wallet balance:', error);
    throw error;
  }
};

// Get deposit address for user
export const getDepositAddress = async (userId: string) => {
  try {
    const token = localStorage.getItem('auth_token') || localStorage.getItem('privy:token');
    
    // Set the auth token in headers
    const response = await api.get('/wallet/deposit', {
      headers: {
        'x-auth-token': token
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting deposit address:', error);
    throw error;
  }
};

// Withdraw funds
export const initiateWithdrawal = async (userId: string, destinationAddress: string, amount: number) => {
  try {
    const token = localStorage.getItem('auth_token') || localStorage.getItem('privy:token');
    
    // Set the auth token in headers
    const response = await api.post('/wallet/withdraw', {
      destinationAddress,
      amount
    }, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error initiating withdrawal:', error);
    throw error;
  }
};

// Hooks to use in React components
export const useWalletsHelper = () => {
  return useWallets();
}; 